/**
 * The three mutually-exclusive ring style modes.
 *
 * - 'gems'   → show gem sub-selector; no shader pattern
 * - 'groove' → die-wall groove shader; no gem
 * - 'wave'   → sine-wave band shader; no gem
 */
export type StyleMode = 'gems' | 'groove' | 'wave';

export interface StyleOption {
    id: StyleMode;
    labelDe: string;
    description: string;
    icon: string;
}

export const STYLE_OPTIONS: StyleOption[] = [
    {
        id: 'gems',
        labelDe: 'Stein',
        description: 'Edelstein einsetzen',
        icon: '◇',
    },
    {
        id: 'groove',
        labelDe: 'Rille',
        description: 'Kreisförmige Rille an der Stirnseite',
        icon: '◎',
    },
    {
        id: 'wave',
        labelDe: 'Welle',
        description: 'Sinusförmiges Zierband',
        icon: '∿',
    },
];
